import {
  ADD_INHOUDINGEN,
  ADD_TOELAGEN,
  CALCULATE_TAX_TABLE,
  SAVE_COMP_DETAILS,
  SAVE_EMPLOYEE_DATA,
  SAVE_TAX_CALC_INPUT,
  STORE_RESPONSE,
  UPLOAD_IMAGE,
} from "../actions/actionTypes";

import data from "../../testData.json";

const initialState = {
  toelagen: [],
  inhoudingen: [],
  taxTableResponse: {},
  taxCalcData: {
    forfait: 4.0,
    taxFreeSum: 7500.0,
    heffingskorting: 0,
    sc1min: 0,
    sc1max: 946.4,
    sc1per: 8,
    sc2min: 946.4,
    sc2max: 1606.15,
    sc2per: 18,
    sc3min: 1606.15,
    sc3max: 2516.15,
    sc3per: 28,
    sc4min: 2516.15,
    sc4max: null,
    sc4per: 38,
    sc5min: null,
    sc5max: null,
    sc5per: null,
  },
  uploadedImage: "",
  companyInformation: {
    imgPreview: "",
    companyLogo: "",
    companyNaam: "",
    adres: "",
    telefoonnummer: "",
    mobiel: "",
    land_stad: "",
    startDatumSalarisRonde: "",
    eindDatumSalarisRonde: "",

    // imgPreview: '',
    // companyLogo: '',
    // companyNaam: 'comp naam Acme',
    // adres: 'adres',
    // telefoonnummer: 'tel',
    // mobiel: 'movl',
    // land_stad: 'land',
    // startDatumSalarisRonde: 'tart',
    // eindDatumSalarisRonde: 'eind'
  },
  employeeData: "",
  response: null,
  /* company: {
      companyLogo: "",
      companyNaam: "comp naam",
      adres: "adres",
      telefoonnummer: "tel",
      mobiel: "movl",
      land_stad: "land",
      startDatumSalarisRonde: "01-10-2020",
      eindDatumSalarisRonde: "31-10-2020",
    },
    loonbelastingRapport: {
      aantalWerknemers: "19",
      totaalAOV: "4,092.59",
      totaalLoonbelasting: "25,472.95",
      totaalTeBetalen: "29,565.54",
      totaalVerloondBedrag: "187,130.19",
    },
    loonstroken: [
      {
        loonslipData: {
          brutoSalaris: "0.01",
          belastingInhoudingBrutosalaris: "750.00",
          afTeDragenLoonbelasting: "0.00",
          aovBedrag: "0.00",
          toelagenSom: "2,945.00",
          inhoudingenSom: "0.00",
          nettoInkomen: "2,945.01",
          totaalTeOntvangen: "2,945.01",
          heffingskorting: "750.00",
          totaalInhoudingen: "0.00",
          toelage1: {
            label: "quarantaine toelage",
            bedrag: "1,125.00",
          },
          toelage2: {
            label: "Vervoerstoelage",
            bedrag: "0.00(13.00%)",
          },
          toelage3: {
            label: "Onkostenvergoeding",
            bedrag: "0.00(16.00%)",
          },
          toelage4: {
            label: "Covid Toelage",
            bedrag: "1,320.00",
          },
          toelage5: {
            label: "koerscompensatie",
            bedrag: "500.00",
          },
          toelage6: {
            label: "",
            bedrag: "",
          },
          toelage7: {
            label: "",
            bedrag: "",
          },
          inhouding1: {
            label: "Bondshop",
            bedrag: "",
          },
          inhouding2: {
            label: "",
            bedrag: "",
          },
          inhouding3: {
            label: "",
            bedrag: "",
          },
          inhouding4: {
            label: "",
            bedrag: "",
          },
          inhouding5: {
            label: "",
            bedrag: "",
          },
          inhouding6: {
            label: "",
            bedrag: "",
          },
          inhouding7: {
            label: "",
            bedrag: "",
          },
        },
        employee: {
          naam: "Ryan Lonty",
          personeelsNummer: "0001",
          idNummer: "",
        },
      },
      {
        loonslipData: {
          brutoSalaris: "0.01",
          belastingInhoudingBrutosalaris: "750.00",
          afTeDragenLoonbelasting: "0.00",
          aovBedrag: "0.00",
          toelagenSom: "2,945.00",
          inhoudingenSom: "0.00",
          nettoInkomen: "2,945.01",
          totaalTeOntvangen: "2,945.01",
          heffingskorting: "750.00",
          totaalInhoudingen: "0.00",
          toelage1: {
            label: "quarantaine toelage",
            bedrag: "1,125.00",
          },
          toelage2: {
            label: "Vervoerstoelage",
            bedrag: "0.00(13.00%)",
          },
          toelage3: {
            label: "Onkostenvergoeding",
            bedrag: "0.00(16.00%)",
          },
          toelage4: {
            label: "Covid Toelage",
            bedrag: "1,320.00",
          },
          toelage5: {
            label: "koerscompensatie",
            bedrag: "500.00",
          },
          toelage6: {
            label: "",
            bedrag: "",
          },
          toelage7: {
            label: "",
            bedrag: "",
          },
          inhouding1: {
            label: "Bondshop",
            bedrag: "",
          },
          inhouding2: {
            label: "",
            bedrag: "",
          },
          inhouding3: {
            label: "",
            bedrag: "",
          },
          inhouding4: {
            label: "",
            bedrag: "",
          },
          inhouding5: {
            label: "",
            bedrag: "",
          },
          inhouding6: {
            label: "",
            bedrag: "",
          },
          inhouding7: {
            label: "",
            bedrag: "",
          },
        },
        employee: {
          naam: "Amarja Popcorni",
          personeelsNummer: "0002",
          idNummer: "",
        },
      },
    ], */
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_TAX_CALC_INPUT:
      return {
        ...state,
        taxCalcData: action.payload,
      };

    case SAVE_COMP_DETAILS:
      return {
        ...state,
        companyInformation: action.payload,
      };

    case SAVE_EMPLOYEE_DATA:
      return {
        ...state,
        employeeData: action.payload,
      };

    case STORE_RESPONSE:
      return {
        ...state,
        response: action.payload,
      };

    case ADD_TOELAGEN:
      return {
        ...state,
        toelagen: action.payload,
      };

    case ADD_INHOUDINGEN:
      return {
        ...state,
        inhoudingen: action.payload,
      };

    case CALCULATE_TAX_TABLE:
      return {
        ...state,
        taxTableResponse: action.payload,
      };

    case UPLOAD_IMAGE:
      return {
        ...state,
        uploadedImage: action.payload,
      };

    default:
      return state;
  }
}
